module.exports = __webpack_public_path__ + "img/FCB-2.a7003064.jpg";